import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TOsiraseListGetReq,
  TOsiraseGetListRes,
  TOsiraseRegisterPostReq,
  TOsiraseUpdatePutReq,
  TOsiraseDeleteReq,
} from "./TOsirase"

/**
 * お知らせに対するAPIリクエスト用サービス
 *
 * @export
 * @class OsiraseService
 * @extends {ConnectApi}
 */
export default class OsiraseService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TOsiraseListGetReq} params
   * @param {(param: TApiResponse<TOsiraseGetListRes[]>) => any} resolve
   * @param {(param: TApiResponse<TOsiraseGetListRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TOsiraseListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TOsiraseGetListRes[]>> =
        await this.getInner(`/master/osirase`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {id} id
   * @memberof OsiraseService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TOsiraseGetListRes>> =
        await this.getInner(`/master/osirase/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TOsiraseRegisterPostReq} data
   * @memberof OsiraseService
   */
  post = async (data: TOsiraseRegisterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/osirase`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TOsiraseUpdatePutReq} data
   * @memberof OsiraseService
   */
  put = async (id: number, data: TOsiraseUpdatePutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/osirase/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体削除
   *
   * @param {TOsiraseDeleteReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof HinmeiService
   */
  delete = async (
    id: number,
    data: TOsiraseDeleteReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.deleteInner(
        `master/osirase/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
